import Orders from "../components/Orders/Orders.tsx";


const Dashboard: React.FC = () => {

  return (
    <>
    <Orders />
    </>

  );
};

export default Dashboard;
